import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import type { IRegistrationPage } from '../entities/registration-page.model';

/**
 * Authenticated surface of the registration Worker for the gym's default
 * registration link.
 *
 * The tenant never travels in a request: the Worker derives it from the bearer.
 * `withCredentials: true` is what makes the interceptor attach that bearer.
 */
@Injectable({ providedIn: 'root' })
export class RegistrationPageService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.registration_service;

  /** 404 means the gym has not created its public address yet. */
  public getPage(): Observable<IRegistrationPage> {
    return this.http.get<IRegistrationPage>(`${this.baseUrl}/api/page`, { withCredentials: true });
  }
}
